<template>
  <div>
    <div class="page-head">
      <div>
        <h2>系统参数</h2>
        <p>配置微信小程序登录参数和微信支付商户参数。</p>
      </div>
    </div>

    <el-card shadow="never" class="settings-card">
      <div slot="header">微信小程序</div>
      <el-form label-width="150px" :model="miniProgram">
        <el-form-item label="AppID"><el-input v-model="miniProgram.app_id" placeholder="小程序 AppID" /></el-form-item>
        <el-form-item label="AppSecret"><el-input v-model="miniProgram.app_secret" show-password placeholder="小程序 AppSecret" /></el-form-item>
      </el-form>
    </el-card>

    <el-card shadow="never" class="settings-card">
      <div slot="header">微信支付</div>
      <el-form label-width="150px" :model="wechatPay">
        <el-form-item label="商户号"><el-input v-model="wechatPay.mch_id" placeholder="微信支付商户号" /></el-form-item>
        <el-form-item label="APIv3 密钥"><el-input v-model="wechatPay.api_v3_key" show-password placeholder="APIv3 Key" /></el-form-item>
        <el-form-item label="商户证书序列号"><el-input v-model="wechatPay.merchant_serial_no" placeholder="Merchant Serial No" /></el-form-item>
        <el-form-item label="支付回调地址"><el-input v-model="wechatPay.notify_url" placeholder="https://example.com/api/miniprogram/payments/callback" /></el-form-item>
        <el-form-item label="商户私钥">
          <el-input v-model="wechatPay.private_key" type="textarea" :rows="6" placeholder="-----BEGIN PRIVATE KEY-----" />
        </el-form-item>
      </el-form>
    </el-card>

    <el-card shadow="never" class="settings-card">
      <div slot="header">小程序页面图片</div>
      <el-form label-width="150px" :model="miniProgramImages">
        <el-form-item label="首页头图"><asset-upload v-model="miniProgramImages.home_hero" category="mini-program" /></el-form-item>
        <el-form-item label="首页地图图"><asset-upload v-model="miniProgramImages.home_scenic_map" category="mini-program" /></el-form-item>
        <el-form-item label="咨询服务图"><asset-upload v-model="miniProgramImages.service_consult" category="mini-program" /></el-form-item>
        <el-form-item label="定制服务图"><asset-upload v-model="miniProgramImages.service_custom" category="mini-program" /></el-form-item>
        <el-form-item label="推荐线路头图"><asset-upload v-model="miniProgramImages.featured_hero" category="mini-program" /></el-form-item>
        <el-form-item label="文化体验头图"><asset-upload v-model="miniProgramImages.culture_hero" category="mini-program" /></el-form-item>
        <el-form-item label="景点地图图"><asset-upload v-model="miniProgramImages.scenic_map" category="mini-program" /></el-form-item>
        <el-form-item label="定制需求头图"><asset-upload v-model="miniProgramImages.custom_demand_hero" category="mini-program" /></el-form-item>
        <el-form-item label="高端定制头图"><asset-upload v-model="miniProgramImages.custom_high_hero" category="mini-program" /></el-form-item>
        <el-form-item label="推荐官弹窗图"><asset-upload v-model="miniProgramImages.profile_referral" category="mini-program" /></el-form-item>
      </el-form>
    </el-card>

    <div class="settings-actions">
      <el-button type="primary" :loading="saving" @click="save">保存参数</el-button>
    </div>
  </div>
</template>

<script>
import { createResource, listResource, updateResource } from "../api/resources";
import AssetUpload from "../components/AssetUpload.vue";

const defaults = {
  wechat_mini_program: { app_id: "", app_secret: "" },
  wechat_pay: { mch_id: "", api_v3_key: "", merchant_serial_no: "", private_key: "", notify_url: "" },
  mini_program_images: {
    home_hero: "/uploads/images/managed/home-beijing-hero.jpg",
    home_scenic_map: "/uploads/images/managed/home-scenic-map-beijing.png",
    service_consult: "/uploads/images/managed/service-consult.jpg",
    service_custom: "/uploads/images/managed/service-custom.jpg",
    featured_hero: "/uploads/images/managed/featured-hero.jpg",
    culture_hero: "/uploads/images/managed/culture-hero.jpg",
    scenic_map: "/uploads/images/managed/scenic-map-art.jpg",
    custom_demand_hero: "/uploads/images/managed/custom-high-hero.jpg",
    custom_high_hero: "/uploads/images/managed/custom-high-clean-hero.jpg",
    profile_referral: "/uploads/images/managed/profile-referral-gift-cut.png"
  }
};

function parseValue(value, fallback) {
  if (!value) return { ...fallback };
  if (typeof value === "object") return { ...fallback, ...value };
  try {
    return { ...fallback, ...JSON.parse(value) };
  } catch (error) {
    return { ...fallback };
  }
}

export default {
  name: "SettingsManage",
  components: { AssetUpload },
  data() {
    return {
      saving: false,
      settingRows: {},
      miniProgram: { ...defaults.wechat_mini_program },
      wechatPay: { ...defaults.wechat_pay },
      miniProgramImages: { ...defaults.mini_program_images }
    };
  },
  mounted() {
    this.fetchSettings();
  },
  methods: {
    async fetchSettings() {
      const res = await listResource("settings", { pageSize: 100 });
      const rows = res.data && res.data.items ? res.data.items : [];
      const map = rows.reduce((result, row) => {
        result[row.setting_key] = row;
        return result;
      }, {});
      this.settingRows = map;
      this.miniProgram = parseValue(map.wechat_mini_program && map.wechat_mini_program.setting_value, defaults.wechat_mini_program);
      this.wechatPay = parseValue(map.wechat_pay && map.wechat_pay.setting_value, defaults.wechat_pay);
      this.miniProgramImages = parseValue(map.mini_program_images && map.mini_program_images.setting_value, defaults.mini_program_images);
    },
    async upsertSetting(key, value, description, sortOrder) {
      const row = this.settingRows[key];
      const payload = {
        setting_key: key,
        setting_value: value,
        description,
        status: "active",
        sort_order: sortOrder
      };
      if (row && row.id) return updateResource("settings", row.id, payload);
      return createResource("settings", payload);
    },
    async save() {
      this.saving = true;
      try {
        await Promise.all([
          this.upsertSetting("wechat_mini_program", this.miniProgram, "微信小程序登录参数", 900),
          this.upsertSetting("wechat_pay", this.wechatPay, "微信支付商户参数", 901),
          this.upsertSetting("mini_program_images", this.miniProgramImages, "小程序页面图片配置", 100)
        ]);
        this.$message.success("系统参数已保存");
        this.fetchSettings();
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
.settings-card {
  margin-bottom: 18px;
}

.settings-actions {
  display: flex;
  justify-content: flex-end;
}
</style>
